export default __webpack_public_path__ + "static/media/Propuesta_de_valor_PPT_31MARZO2021.eea49216.pdf";